/*=========================================================================================
  File Name: module-confirm-business-getters.js
  Description: Confirm Business Module Getters
  ----------------------------------------------------------------------------------------
  Project: MISA InvoiceBots
  Author: MISA JSC
  Author URL: http://www.misa.com.vn
==========================================================================================*/

export default {
    ConfirmListBusiness(state) {
        return state.ConfirmListBusiness;
    },
    Total(state) {
        return state.Total;
    },
    IsLoading(state) {
        return state.IsLoading;
    },
};